import { useState, useEffect, useRef } from "react";
import {
  chartGrid,
  chartInk,
  chartLabel,
  useThemeMode,
} from "../../contexts/theme-mode";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import "./bar4.style.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderRadius: 5,
};

export default function Bar4({ value, onClick }) {
  const { mode } = useThemeMode();
  const [data, setData] = useState({ datasets: [] });
  const [options, setOptions] = useState(defaultOptions);

  useEffect(() => {
    const newData = {
      labels: [],
      datasets: [
        {
          barPercentage: 1.15,
          categorySpacing: 0,
          data: [],
          backgroundColor: chartInk(mode),
        },
      ],
    };

    const labelColor = chartLabel(mode);
    const newOptions = {
      ...defaultOptions,
      color: labelColor,
      scales: {
        y: {
          ticks: {
            stepSize: 5,
            min: 0,
            color: labelColor,
          },
          grid: {
            color: chartGrid(mode),
          },
        },
        x: {
          ticks: {
            color: labelColor,
          },
          grid: {
            display: false,
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        datalabels: {
          anchor: 'end',
          align: 'end',
          color: labelColor,
          offset: 0,
          font: {
            weight: 'bold'
          },
          formatter: function (value) {
            return value;
          }
        },
      },
    };

    setData(newData);
    setOptions(newOptions);
  }, [mode]);

  useEffect(() => {
    const values = {
      label: [],
      bar: []
    }

    value.map((item) => {
      let truncatedString = item.product_name.substring(0, 6);

      if (item.product_name.length > 6) {
        truncatedString += "...";
      }
      values.label.push(truncatedString);
      values.bar.push(item?.inventory_quantity_needed?.toFixed(2));
    });

    const newData = {
      labels: values.label,
      datasets: [
        {
          barPercentage: 1.15,
          categorySpacing: 0,
          data: values.bar,
          backgroundColor: chartInk(mode),
        },
      ],
    };

    setData(newData);
  }, [value, mode]);

  return (
    <div className="bar4-body" onClick={onClick}>
      <div className="bar4-container">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
}
